var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 5H12.334C10.1248 5 8.33398 6.79086 8.33398 9V31C8.33398 33.2091 10.1248 35 12.334 35H28.334C30.5431 35 32.334 33.2091 32.334 31V9C32.334 6.79086 30.5431 5 28.334 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.334 26.9996C24.7523 26.9996 28.334 23.4179 28.334 18.9996C28.334 14.5814 24.7523 10.9996 20.334 10.9996C15.9157 10.9996 12.334 14.5814 12.334 18.9996C12.334 23.4179 15.9157 26.9996 20.334 26.9996Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.334 26.9996C21.9908 26.9996 23.334 23.4179 23.334 18.9996C23.334 14.5814 21.9908 10.9996 20.334 10.9996C18.6771 10.9996 17.334 14.5814 17.334 18.9996C17.334 23.4179 18.6771 26.9996 20.334 26.9996Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 19H28.334",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.763c793566094f5836fbe878d96fc066.svg";
export { ForwardRef as ReactComponent };